import { render, staticRenderFns } from "./devoluciones-y-garantias.vue?vue&type=template&id=5475c261&"
import script from "./devoluciones-y-garantias.vue?vue&type=script&lang=js&"
export * from "./devoluciones-y-garantias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports